import { EyeOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Modal, Table, Tag } from "antd";
import React, { useState } from "react";
import { fetchTrainLogs } from "../../../../../api/apiCallManager";
import { getCurrentRole } from "../../../../../helpers/authFunctions";
import { useProjectInfoStore } from "./../../../../../zustand/store/projectInfoStore";
import { FiDownload } from "react-icons/fi";
function ClientLogsTab({ selectedPatch, clientsData }) {
  // const [activeKey, setActiveKey] = useState("TRAIN_LOGS");
  const { projectInfoZustandState } = useProjectInfoStore();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const currentRole = getCurrentRole();

  let logsPayload = {
    clients: clientsData?.clients,
    patch_version: selectedPatch,
    server: clientsData?.server,
    projectKey: projectInfoZustandState?.project_key,
  };

  const { data, error, isLoading } = useQuery({
    queryKey: ["logs_", selectedPatch, projectInfoZustandState?.project_key], // Unique query key
    queryFn: () => fetchTrainLogs(logsPayload), // API call function
  });
  // Handle modal open and close
  const showModal = (logContent) => {
    setModalContent(logContent);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setModalContent("");
  };
  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      type: "Client",
      render: (data) => (
        <Tag color={data == "Client" ? "blue" : "red"}>{data}</Tag>
      ),
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Logs",
      key: "action",
      render: (_, record) => (
        <EyeOutlined
          style={{ fontSize: "18px", cursor: "pointer", color: "#1890ff" }}
          onClick={() => showModal(record.log_content)}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "download_url",
      key: "download_",
      render: (data, rec) => (
        <>
          <a href={data} target="_blank">
            <FiDownload size={17} color="#1890ff" />
          </a>
        </>
      ),
    },
  ];
  let tableData = [];
  if (Array.isArray(data?.client_logs)) {
    tableData = data.client_logs.map((log, index) => ({
      key: index,
      clientName: log?.clientName,
      type: "Client",
      download_url: log?.download_url,
      log_content: log?.log_content,
    }));
  }

  const server = {
    key: "server06",
    clientName: "-",
    type: "Server",
    download_url: data?.server_logs?.[0]?.download_url,
    log_content: data?.server_logs?.[0]?.log_content || "",
  };
  let dataSource = [];
  if (data?.client_logs?.length == 0) {
    dataSource = [];
  } else {
    dataSource = [...tableData, server];
  }

  // let dataSource = [...tableData];

  // if (data?.server_logs?.length > 0) {
  //   dataSource.push(server);
  // }

  return (
    <div className="px-5  pt-2">
      {selectedPatch && (
        <Table
          className="user-table-theme"
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          pagination={false}
        />
      )}
      {/* Modal for showing log content */}
      <div className="my-4"></div>
      <Modal
        width={"100%"}
        title="Logs"
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={[
          <Button key="close" onClick={handleModalClose}>
            Close
          </Button>,
        ]}
      >
        <div className="py-1"></div>
        <pre className=" whitespace-pre-wrap text-[14px] bg-black overflow-auto p-[22px] rounded-sm text-[#ffeed0]  max-h-[600px]">
          {modalContent}
        </pre>
      </Modal>
    </div>
  );
}

export default ClientLogsTab;
